<template>
  <div class="UserPackage-detail-page w-100">
    <b-form @submit="handleValidate">
      <basic-subheader>
        <template v-slot:actions>
          <b-button
            class="btn btn-light ml-3"
            type="button"
            @click="returnPage"
          >
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
            </span>
            Huỷ
          </b-button>

          <template v-if="isUpdatePermission">
            <b-button class="btn btn-success ml-3" @click.stop="handleValidate">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
              </span>
              {{ isView ? 'Chỉnh sửa' : 'Lưu' }}
            </b-button>
          </template>
        </template>
      </basic-subheader>
      <b-overlay :show="loading">
        <b-container fluid class="UserPackage-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <h5 class="card-title text-success">Thông tin UserPackage</h5>
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <basic-select
                            label="Loại nhắc nhở"
                            placeholder="Zalo"
                            name="reminderMethod"
                            data-vv-As="Loại nhắc nhở"
                            :options="reminderMethodOptions"
                            :required="true"
                            :disabled="isView"
                            v-validate="'required'"
                            :value.sync="form.reminderMethod"
                            :state="validateState('reminderMethod')"
                            :invalidFeedback="errors.first('reminderMethod')"
                            track-by="value"
                            value-label="text"
                            @input="
                              selected(
                                $event,
                                'reminderMethod',
                                reminderMethodOptions,
                              )
                            "
                          ></basic-select>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Tên gói"
                            placeholder="Name"
                            name="name"
                            data-vv-As="Name"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.name"
                            :state="validateState('name')"
                            :invalidFeedback="errors.first('name')"
                            :disabled="isView"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-input
                            label="Số điện thoại"
                            placeholder="Số điện thoại"
                            name="phoneNumber"
                            data-vv-As="Số điện thoại"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.phoneNumber"
                            :state="validateState('phoneNumber')"
                            :invalidFeedback="errors.first('phoneNumber')"
                            :disabled="isView"
                          ></basic-input>
                        </b-col>
                        <b-col>
                          <basic-select
                            label="Cấp độ"
                            placeholder="Cấp độ"
                            name="level"
                            data-vv-As="Cấp độ"
                            :required="true"
                            v-validate="required"
                            :options="levels"
                            :disabled="isView"
                            track-by="value"
                            value-label="text"
                            :value.sync="form.level"
                            :state="validateState('level')"
                            :invalidFeedback="errors.first('level')"
                            @input="selected($event, 'level', levels)"
                          ></basic-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <basic-select
                            label="Gói dịch vụ"
                            placeholder="--- Chọn gói dịch vụ ---"
                            data-vv-As="Gói dịch vụ"
                            track-by="id"
                            :disabled="isView"
                            value-label="text"
                            :options="servicePackages"
                            :value.sync="form.selectedservicePackage"
                            name="servicePackage"
                            v-validate="'required'"
                            :state="validateState('servicePackage')"
                            :invalidFeedback="errors.first('servicePackage')"
                            @input="
                              selected(
                                $event,
                                'servicePackage',
                                servicePackages,
                              )
                            "
                          />
                        </b-col>

                        <b-col>
                          <basic-date-picker
                            label="Ngày bắt đầu"
                            placeholder="Ngày bắt đầu"
                            name="startDate"
                            data-vv-As="StartDate"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.startDate"
                            :state="validateState('startDate')"
                            :invalidFeedback="errors.first('startDate')"
                            format="DD/MM/YYYY"
                            :disabled="isView"
                          />
                        </b-col>
                        <b-col>
                          <basic-date-picker
                            label="Ngày kết thúc"
                            placeholder="Ngày kết thúc"
                            name="endDate"
                            data-vv-As="endDate"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="form.endDate"
                            :state="validateState('endDate')"
                            :invalidFeedback="errors.first('endDate')"
                            format="DD/MM/YYYY"
                            :disabled="isView"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>

        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import 'vue2-datepicker/index.css';
import {
  convertDateToTimestamp,
  convertTimestampToDate,
} from '@/core/mixins/index.js';

export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
    // item: {
    //   type: Object,
    //   default: () => ({}),
    // },
  },
  data() {
    return {
      levels: [
        {
          text: 'Level 0',
          value: 0,
        },
        {
          text: 'Level 1',
          value: 1,
        },
        {
          text: 'Level 2',
          value: 2,
        },
        {
          text: 'Level 3',
          value: 3,
        },
        {
          text: 'Level 4',
          value: 4,
        },
      ],
      reminderMethodOptions: [
        { value: 0, text: 'Thông báo qua nhóm Zalo' },
        { value: 1, text: 'Thông báo qua ứng dụng DIAB' },
        { value: 2, text: 'Đồng thời qua nhóm Zalo và ứng dụng DIAB' },
      ],
      isView: true,
      servicePackages: [],
      form: {
        Code: null,
        Name: null,
        Level: null,
        ServicePackageId: null,
        SaleMoney: null,
        Status: null,
        StartDate: null,
        EndDate: null,
        selectedservicePackage: null,
        phoneNumber: null,
      },

      file: null,
      preview: null,
      loading: false,
    };
  },

  created() {
    // this.initDataInSelect();
  },
  mounted() {
    const item = this.$route.params.item;
    const optionsPackage = this.$route.params.package;
    const optionReminderMethod = this.$route.params.item.reminderMethod;

    // access the item object
    this.form = {
      id: item.id,
      code: item.code,
      name: item.name,
      phoneNumber: item.phoneNumber,
      level: this.levels.find((level) => level.value == item.level),
      saleMoney: item.saleMoney,
      status: item.status,
      startDate: convertTimestampToDate(item.startDate),
      endDate: convertTimestampToDate(item.endDate),
    };
    this.servicePackages = (optionsPackage || []).map((el) => {
      return {
        id: el.id,
        text: el.name,
      };
    });
    this.form.selectedservicePackage = this.servicePackages.filter(
      (v) => v.id == item.servicePackageId,
    )[0];

    this.form.reminderMethod = this.reminderMethodOptions.find(
      (option) => option.value === optionReminderMethod,
    );
  },
  computed: {
    isCreateForm() {
      return this.form_type === 'create' || this.form_type === 'copy';
    },
  },
  methods: {
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] = value
        ? optionsArr.find((el) => el.value === value)
        : null;
      if (this.form[formProperty]) {
        this.$validator.reset({ name: formProperty });
      }
    },
    resetData() {
      this.form.code = null;
      this.form.name = null;
      this.form.level = null;
      this.form.servicePackageId = null;
      this.form.saleMoney = null;
      this.form.status = null;
      this.form.startDate = null;
      this.form.endDate = null;
    },
    handleChangeSelect(value, formProperty) {
      console.log('isShowError', this.isShowError);
      var newOptions = value ? value[0] : null;
      switch (formProperty) {
        case 'servicePackage':
          this.selectedservicePackage = newOptions;
          break;
        default:
          break;
      }
    },

    async initDataInSelect() {
      try {
        this.loading = true;

        const [servicePackageList] = await Promise.all([
          this.$api.get(`/servicePackage`, { params: { size: 1000 } }),
        ]);

        this.servicePackages = this.mapDataSelect(servicePackageList);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle error appropriately, e.g., show error message
      } finally {
        this.loading = false;
      }
    },
    mapDataSelect(response) {
      return response?.data.items.map((value) => {
        return {
          id: value?.id,
          text: value?.name ?? value?.description,
        };
      });
    },
    clear() {
      this.preview = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'user_package_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      // let result = await this.$validator.validateAll();
      // if (!result) {
      //   return;
      //  } else {

      if (this.isView == false) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.submit();
          } else {
            this.$toast.e({
              message: 'Vui lòng kiểm tra lại thông tin',
            });
          }
        });
      }
      //    this.submit();
      //   }
      this.isView = false;
    },
    async submit() {
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      this.form.code && payload.append('code', this.form.code);
      this.form.name && payload.append('name', this.form.name);
      this.form.level &&
        payload.append(
          'level',
          typeof this.form.level === 'object'
            ? this.form.level.value
            : this.form.level,
        );
      this.form.saleMoney && payload.append('saleMoney', this.form.saleMoney);
      // this.form.status &&
      //   payload.append('status', this.form.status);
      this.form.startDate &&
        payload.append(
          'startDate',
          convertDateToTimestamp(this.form.startDate),
        );
      this.form.endDate &&
        payload.append('endDate', convertDateToTimestamp(this.form.endDate));

      this.form.selectedservicePackage &&
        payload.append('ServicePackageId', this.form.selectedservicePackage.id);
      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo UserPackage mới này không? '
            : 'Bạn có chắc muốn cập nhật thông tin UserPackage này hay không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        this.handleUpdate(payload);
      }
    },

    async handleUpdate(payload) {
      payload.append('id', this.form.id);
      try {
        this.loading = true;
        const id = this.form.id;
        await this.$api.put(`UserPackage/${id}`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Chúc mừng, UserPackage đã được cập nhật!',
        });
        this.$router.push({ name: 'user_package_list' });
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: e.message,
        });
      } finally {
        this.loading = false;
      }
    },

    // async loadUserPackageData() {
    //   if (!this.$route.params.id) return;
    //   try {
    //     this.loading = true;
    //     const id = this.$route.params.id;
    //     let { data } = await this.$api.get(`UserPackage/${id}`);
    //     this.form = data;
    //   } catch (error) {
    //     this.$toastr.e({
    //       title: 'Lỗi!',
    //       msg: error,
    //     });
    //   } finally {
    //     this.loading = false;
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}

.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}

.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}
</style>
